const data = {
  state: {
    original: null,
    orgDetailBasic: null, // original document detail basic
    dataSource: null,
    commsGlobal: null,
    dataPrivacyAgree: false,
    termsAndCondAgree: false,
    dataSavePendingIndication: false,
    enableNavigationBarMove: false,
    searchResults: null,
    searchResultsCounter: null,
    searchReports: null,
    searchReportsCounter: null,
    searchResultsSort: null,
    assetTreeInfoCard: null,
    importedList: null,
    commsList: null,
    commsDialog: false,
    registerInfo: null,
    treeInfo: null,
    treeMasterInfo: null,
    treeParentInfo: null
  },
  mutations: {
    changeRegisterInfo(state, payload) {
      state.registerInfo = payload;
    },
    changeEnableNavigationBarMove(state, payload) {
      state.enableNavigationBarMove = payload;
    },
    changeTreeInfo(state, payload) {
      state.treeInfo = payload;
    },
    changeTreeMasterInfo(state, payload) {
      state.treeMasterInfo = payload;
    },
    changeTreeParentInfo(state, payload) {
      state.treeParentInfo = payload;
    },
    changeDataPrivacyAgree(state, payload) {
      state.dataPrivacyAgree = payload;
    },
    changeTermsAndCondAgree(state, payload) {
      state.termsAndCondAgree = payload;
    },
    changeAssetTreeInfoCard(state, payload) {
      state.assetTreeInfoCard = payload;
    },
    changeOriginal(state, payload) {
      state.original = payload;
    },
    changeCommsGlobal(state, payload) {
      state.commsGlobal = payload;
    },
    changeOrgDetailBasic(state, payload) {
      state.orgDetailBasic = payload;
    },
    changeSearchResults(state, payload) {
      state.searchResults = payload;
    },
    changeSearchResultsCounter(state, payload) {
      state.searchResultsCounter = payload;
    },
    changeSearchReports(state, payload) {
      state.searchReports = payload;
    },
    changeSearchReportsCounter(state, payload) {
      state.searchReportsCounter = payload;
    },
    changeSearchReportsSort(state, payload) {
      state.searchReportsSort = payload;
    },
    changeImportedList(state, payload) {
      state.importedList = payload;
    },
    changeCommsList(state, payload) {
      state.commsList = payload;
    },
    changeCommsDialog(state, payload) {
      state.commsDialog = payload;
    },
    changeDataSource(state, payload) {
      state.dataSource = payload;
    },
    changeDataSavePendingIndication(state, payload) {
      state.dataSavePendingIndication = payload;
    }
  },
  actions: {
    changeRegisterInfo({ commit }, payload) {
      commit("changeRegisterInfo", payload);
    },
    changeEnableNavigationBarMove({ commit }, payload) {
      commit("changeEnableNavigationBarMove", payload);
    },
    changeTreeInfo({ commit }, payload) {
      commit("changeTreeInfo", payload);
    },
    changeTreeMasterInfo({ commit }, payload) {
      commit("changeTreeMasterInfo", payload);
    },
    changeTreeParentInfo({ commit }, payload) {
      commit("changeTreeParentInfo", payload);
    },
    changeDataPrivacyAgree({ commit }, payload) {
      commit("changeDataPrivacyAgree", payload);
    },
    changeTermsAndCondAgree({ commit }, payload) {
      commit("changeTermsAndCondAgree", payload);
    },
    changeAssetTreeInfoCard({ commit }, payload) {
      commit("changeAssetTreeInfoCard", payload);
    },
    changeOriginal({ commit }, payload) {
      commit("changeOriginal", payload);
    },
    changeCommsGlobal({ commit }, payload) {
      commit("changeCommsGlobal", payload);
    },
    changeOrgDetailBasic({ commit }, payload) {
      commit("changeOrgDetailBasic", payload);
    },
    changeSearchResults({ commit }, payload) {
      commit("changeSearchResults", payload);
    },
    changeSearchResultsCounter({ commit }, payload) {
      commit("changeSearchResultsCounter", payload);
    },
    changeSearchReports({ commit }, payload) {
      commit("changeSearchReports", payload);
    },
    changeSearchReportsCounter({ commit }, payload) {
      commit("changeSearchReportsCounter", payload);
    },
    changeSearchResultsSort({ commit }, payload) {
      commit("changeSearchResultsSort", payload);
    },
    changeImportedList({ commit }, payload) {
      commit("changeImportedList", payload);
    },
    changeCommsList({ commit }, payload) {
      commit("changeCommsList", payload);
    },
    changeCommsDialog({ commit }, payload) {
      commit("changeCommsDialog", payload);
    },
    changeDataSource({ commit }, payload) {
      commit("changeDataSource", payload);
    },
    changeDataSavePendingIndication({ commit }, payload) {
      commit("changeDataSavePendingIndication", payload);
    }
  },
  getters: {
    getRegisterInfo: state => {
      return state.registerInfo;
    },
    getEnableNavigationBarMove: state => {
      return state.enableNavigationBarMove;
    },
    getTreeInfo: state => {
      return state.treeInfo;
    },
    getTreeMasterInfo: state => {
      return state.treeMasterInfo;
    },
    getTreeParentInfo: state => {
      return state.treeParentInfo;
    },
    getDataPrivacyAgree: state => {
      return state.dataPrivacyAgree;
    },
    getTermsAndCondAgree: state => {
      return state.termsAndCondAgree;
    },
    getAssetTreeInfoCard: state => {
      return state.assetTreeInfoCard;
    },
    getOriginal: state => {
      return state.original;
    },
    getCommsGlobal: state => {
      return state.commsGlobal;
    },
    getOrgDetailBasic: state => {
      return state.orgDetailBasic;
    },
    getSearchResults: state => {
      return state.searchResults;
    },
    getSearchResultsCounter: state => {
      return state.searchResultsCounter;
    },
    getSearchReports: state => {
      return state.searchReports;
    },
    getSearchReportsCounter: state => {
      return state.searchReportsCounter;
    },
    getSearchResultsSort: state => {
      return state.searchResultsSort;
    },
    getImportedList: state => {
      return state.importedList;
    },
    getCommsList: state => {
      return state.commsList;
    },
    getCommsDialog: state => {
      return state.commsDialog;
    },
    getDataSavePendingIndication: state => {
      return state.dataSavePendingIndication;
    },
    getDataSource: state => {
      return state.dataSource;
    }
  }
};
// eslint-disable-next-line
export default data;
